import * as React from 'react';
import { H2, Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import '../../../models/cart/cart-state.js';
import '../../../models/checkout/checkout-step-error-type.js';
import '../../../models/checkout-settings.js';
import { ShippingMethod } from '../../../models/step-shipping/shipping-methods.js';
import '../../../models/shared.js';
import '@swc/helpers';
import '@grandvisionhq/carts-v2';
import '../../../context/CheckoutSettings/context.js';
import '@grandvisionhq/utils';
import '../../../StepShipping/selectors.js';
import 'lodash/isEmpty';
import '../../../mappers/errors-mapping.js';
import '../../../utils/get-customer-details-payload.js';
import 'history';
import '../../../utils/has-cart-errors.js';
import '@grandvisionhq/payments';
import '@grandvisionhq/auth';
import '../../../selectors.js';
import '@grandvisionhq/common';
import '@grandvisionhq/graphql';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-tealium/events';
import '../../../operations/mutations/set-customer-details.js';
import '../../../operations/mutations/set-service-store.js';
import '../../../operations/mutations/set-shipping-method.js';
import '../../../operations/mutations/set-shipping-state.js';
import '../../../operations/mutations/create-apple-pay-session.js';
import '../../../operations/mutations/recreate-ordered-checkout.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../../../operations/fragments/checkout-mutation-result.js';
import '../../../operations/fragments/cart-mutation-failures.js';
import '../../../operations/fragments/recreate-ordered-checkout-failure.js';
import '../../../operations/fragments/recreate-ordered-checkout-result.js';
import '../../../operations/fragments/paypal-payment.js';
import '../../../operations/fragments/saved-user-details.js';
import '../../../operations/queries/get-checkout-state.js';
import '../../../operations/queries/get-user-details.js';
import '@grandvisionhq/icons';
import '@grandvisionhq/locations';
import '../../../StepShipping/modules/ShippingMethods/containers/PickupPointsFinderContainer.js';
import '../../../StepShipping/modules/ShippingMethods/containers/StoresFinderContainer.js';
import { ShippingMethodsListContainer } from '../../../StepShipping/modules/ShippingMethods/containers/ShippingMethodsListContainer.js';
import { SelectedShippingMethodContainer } from '../../../StepShipping/modules/ShippingMethods/containers/SelectedShippingMethodContainer.js';
import '@grandvisionhq/shipping';
import { useShippingStateConfig } from '../../hooks/useShippingStateConfig.js';

const ShippingMethodsContainer = ({ shippingMethodsAsides  })=>{
    var ref, ref1;
    const { getLabel  } = useIntl();
    const shippingConfig = useShippingStateConfig();
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(H2, {
        variant: "heading-small"
    }, getLabel('checkout.instant.shipping.heading')), shippingConfig.shippingMethodList ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ShippingMethodsListContainer, {
        asides: shippingMethodsAsides,
        selectedShippingMethod: shippingConfig === null || shippingConfig === void 0 ? void 0 : shippingConfig.selectedShippingMethod,
        shippingMethodList: shippingConfig.shippingMethodList,
        isLoading: shippingConfig.shippingOptionsLoading,
        error: shippingConfig.shippingOptionsError,
        handleOnShippingMethodSelected: shippingConfig.handleShippingOptionSelection
    }), ((ref = shippingConfig.selectedShippingMethod) === null || ref === void 0 ? void 0 : ref.method) == ShippingMethod.NearestPickup && /*#__PURE__*/ React.createElement(Alert, {
        variant: "info",
        className: "alert-m-default"
    }, getLabel('checkout.summary.shipment.nearestPickup.message')), /*#__PURE__*/ React.createElement(SelectedShippingMethodContainer, {
        selectedShippingMethod: (ref1 = shippingConfig.selectedShippingMethod) === null || ref1 === void 0 ? void 0 : ref1.method,
        onStoreSelect: shippingConfig.onStoreSelect,
        selectedStore: shippingConfig.selectedStore,
        onPickupPointSelect: shippingConfig.onPickupPointSelect,
        selectedPickupPoint: shippingConfig.selectedPickupPoint,
        onShippingModalClose: shippingConfig.onShippingModalClose
    })) : /*#__PURE__*/ React.createElement(Alert, {
        className: "alert-m-default checkout-section__alert",
        variant: "warning",
        title: getLabel('checkout.errors.general.shipping.title')
    }, getLabel('checkout.errors.general.shipping.message')));
};

export { ShippingMethodsContainer };
//# sourceMappingURL=ShippingMethodsContainer.js.map
